module.exports = __webpack_public_path__ + "static/media/ratatool_supplier_en.15b89eb0.png";